<template>
  <svg
    width="47"
    height="47"
    viewBox="0 0 47 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1911_34942)">
      <rect x="2" y="1" width="43" height="43" rx="2.6875" fill="#F7F3FF" />
      <path
        d="M26.0202 28.3789C26.0202 29.7704 24.8922 30.8984 23.5007 30.8984C22.1092 30.8984 20.9811 29.7704 20.9811 28.3789M25.0095 17.6613C25.3752 17.2834 25.6003 16.7686 25.6003 16.2012C25.6003 15.0416 24.6603 14.1016 23.5007 14.1016C22.3411 14.1016 21.4011 15.0416 21.4011 16.2012C21.4011 16.7686 21.6261 17.2834 21.9919 17.6613M28.5397 21.8281C28.5397 20.6699 28.0088 19.5591 27.0638 18.7401C26.1188 17.9211 24.8371 17.4609 23.5007 17.4609C22.1642 17.4609 20.8825 17.9211 19.9375 18.7401C18.9925 19.5591 18.4616 20.6699 18.4616 21.8281C18.4616 23.7445 17.9864 25.146 17.3934 26.1489C16.7175 27.2918 16.3796 27.8633 16.393 27.9998C16.4082 28.156 16.4363 28.2053 16.563 28.2979C16.6737 28.3789 17.23 28.3789 18.3425 28.3789H28.6588C29.7714 28.3789 30.3276 28.3789 30.4383 28.2979C30.565 28.2053 30.5931 28.156 30.6084 27.9998C30.6217 27.8633 30.2838 27.2918 29.608 26.1489C29.015 25.146 28.5397 23.7445 28.5397 21.8281Z"
        stroke="#6434D0"
        stroke-width="1.47812"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1911_34942"
        x="0.65625"
        y="0.328125"
        width="45.6875"
        height="45.6875"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.671875" />
        <feGaussianBlur stdDeviation="0.671875" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1911_34942"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1911_34942"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
